import {toAbsoluteUrl} from '@/_metronic/helpers'
import clsx from 'clsx'
import {FC, useEffect, useMemo, useState} from 'react'
import SVG from 'react-inlinesvg'
import GuestForm from './GuestForm'
import WalkInForm from './WalkInForm'
import {useLocation, useParams} from 'react-router-dom'
import {useBookOrder} from '../../book-order/core/BookOrderProvider'

type Props = {
  outlet_id: string
  handleSubmit: (value: any) => void
}
const BookingForm: FC<Props> = ({outlet_id, handleSubmit}) => {
  const location = useLocation()

  const [bookingType, setBookingType] = useState('guest')
  const {outlet} = useBookOrder()

  const isBooking = useMemo(() => {
    return location.pathname?.startsWith('/booking')
  }, [location])

  useEffect(() => {
    if (isBooking) {
      setBookingType('walkin')
    }
  }, [isBooking])

  return (
    <>
      {!isBooking && (
        <div className='row mt-2'>
          <div className='col-12 mb-8'>
            <h2>{outlet?.outlet_name}</h2>
          </div>
          <div className='col-lg-6'>
            <div
              className='position-relative overflow-hidden cursor-pointer'
              onClick={() => Boolean(outlet_id) && setBookingType('walkin')}
            >
              <label
                className={clsx(
                  'btn btn-outline btn-outline btn-outline-default p-4 d-flex align-items-center justify-content-center mb-10',
                  {
                    'border-primary text-primary': bookingType === 'walkin',
                    bi: bookingType !== 'walkin',
                  }
                )}
                htmlFor='kt_create_account_form_account_type_personal'
              >
                <SVG
                  className='fs-3x me-3'
                  width={30}
                  height={30}
                  src={toAbsoluteUrl(
                    bookingType === 'walkin'
                      ? '/media/svg/orders/ri-hotel-enable.svg'
                      : '/media/svg/orders/ri-hotel-disable.svg'
                  )}
                />

                <span className='d-block fw-bold text-start'>
                  <span className='d-block fs-4'>Walk In</span>
                </span>
              </label>
            </div>
          </div>

          <div className='col-lg-6'>
            <div
              className='position-relative overflow-hidden cursor-pointer'
              onClick={() => Boolean(outlet_id) && setBookingType('guest')}
            >
              <label
                className={clsx(
                  'btn btn-outline btn-outline btn-outline-default p-4 d-flex align-items-center justify-content-center mb-10',
                  {
                    'border-primary text-primary': bookingType === 'guest',
                    bi: bookingType !== 'guest',
                  }
                )}
                htmlFor='kt_create_account_form_account_type_personal'
              >
                <SVG
                  className='fs-3x me-3'
                  width={30}
                  height={30}
                  src={toAbsoluteUrl(
                    bookingType === 'guest'
                      ? '/media/svg/orders/ri-unlock-enable.svg'
                      : '/media/svg/orders/ri-unlock-disable.svg'
                  )}
                />

                <span className='d-block fw-bold text-start'>
                  <span className='d-block fs-4'>Tamu Hotel</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      )}

      {isBooking && <div className='h-15px' />}

      {bookingType === 'guest' && (
        <GuestForm key='guest' outlet_id={outlet_id} handleSubmit={handleSubmit} />
      )}
      {bookingType === 'walkin' && (
        <WalkInForm key='walkin' outlet_id={outlet_id} handleSubmit={handleSubmit} />
      )}
    </>
  )
}

export default BookingForm
